<template>
  <div class="step-container">
    <FunnelHeader :title="t('title')" />
    <SelectionTiles
      v-model="store.downloadSpeed"
      :options="downloadSpeedOptions"
      @click:option="submit"
      name="downloadSpeed-tiles"
    />
  </div>
</template>

<script lang="ts" setup>
import { SelectionTiles, updateForm, useValidateForm } from "cja-phoenix";
import { useBBGtm } from "~/composables/useBBGtm";
import { useBBFunnelStructure } from "~/composables/useBBJourneyConfig";
import { useBBJourneyData } from "~/composables/useBBJourneyData";
import { useBBJourneyStore } from "~/composables/useBBJourneyStore";

const { t } = useI18n();

const { apiURL } = useRuntimeConfig().public;
const { downloadSpeedOptions } = useBBJourneyData();
const { currentStep, goNextStep } = useBBFunnelStructure();
const { trackStepEvent } = useBBGtm("funnel");

const store = useBBJourneyStore();

const { submit } = useValidateForm({
  onSubmit: async () => {
    const payload = {
      downloadSpeed: store.downloadSpeed,
    };

    trackStepEvent({
      stepName: "Internet Usage entered",
      stepNumber: currentStep.value,
      stepDetails: payload,
    });

    await updateForm(apiURL, {
      journeyId: store.journeyId,
      step: currentStep.value,
      stepName: "Internet",
      formType: "FUNNEL",
      payload,
    }).then(() => {
      goNextStep();
    });
  },
  submitLock: true,
});
</script>

<i18n lang="json">
{
  "pt": {
    "title": "Que velocidade de internet precisas?"
  }
}
</i18n>
